import React, { FC } from 'react'
import styled from 'styled-components'
import EmptyStatePage from 'components/dine-in/EmptyStatePage'
import colors from 'styles/colors'
import { Icon } from 'components/base-ui'
import { useTranslation } from 'react-i18next'

interface EmptyLineItemsProps {
  onClick: () => void
}

const EmptyLineItems: FC<EmptyLineItemsProps> = ({ onClick }) => {
  const { gray300 } = colors
  const { t } = useTranslation()

  return (
    <EmptyStateWrapper className="empty-state-page">
      <EmptyStatePage title={t('emptyLineItems')} buttonTitle={t('browsLineItems')} onClickButton={onClick}>
        <Icon name="basket-3" color={gray300} size="85px" />
      </EmptyStatePage>
    </EmptyStateWrapper>
  )
}

export default EmptyLineItems

const EmptyStateWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  display: flex;
  margin-bottom: 94px;
`
